import { render, staticRenderFns } from "./TestResultPopup.vue?vue&type=template&id=4f345d7d&scoped=true"
import script from "./TestResultPopup.vue?vue&type=script&lang=js"
export * from "./TestResultPopup.vue?vue&type=script&lang=js"
import style0 from "./TestResultPopup.vue?vue&type=style&index=0&id=4f345d7d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f345d7d",
  null
  
)

export default component.exports